import { Navigate } from 'react-router';
import routes from '../../routing/routes';
import { useTranslation } from '../../i18n/useTranslation';
import { useWizardPageViewModel } from './wizardPageViewModel';
import { InputSection } from './input/InputSection';
import { Visualisation } from './visualisation/Visualisation';
import { CategorySelectPage } from './category/CategorySelectPage';
import { ErrorScreen } from '../../common/ui/ErrorScreen';
import type { WizardStepName } from '../domain/models';
import { Offscreen } from 'src/lib/common/ui/Offscreen';
import logoImage from 'src/assets/img/callebaut-logo-light.svg';
import styles from './WizardPage.module.scss';

import { AnimatePresence } from "motion/react";
import * as motion from "motion/react-client";

const stepMap: Record<WizardStepName, string> = {
  flavourSelect: 'flavour',
  tasteSelect: 'taste',
  mouthfeelSelect: 'mouthfeel',
  categorySelect: 'category',
};

export function WizardPage() {
  const viewModel = useWizardPageViewModel();
  const { t } = useTranslation();

  const stepKey = viewModel.currentStep
    ? stepMap[viewModel.currentStep.stepName]
    : undefined;

  if (viewModel.currentStep == null) {
    return <Navigate to={ routes.createWizardCategoryUrl() } />;
  }

  if (viewModel.error) {
    return <ErrorScreen error={ viewModel.error } />;
  }

  if (viewModel.currentStep.stepName === 'categorySelect') {
    return (
      <CategorySelectPage />
    );
  };

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }}>
      <div className={ styles.container } data-step={ stepKey }>
        <div className={ styles.containerInner }>

          <Offscreen as='h1'>
            { viewModel.stepTitle }
          </Offscreen>

          {/* visualisation */}
          <div className={ styles.visualisationBlock }>
            <div className={ styles.visualisation }>
              <Visualisation viewModel={ viewModel } />
            </div>
          </div>
          {/* /visualisation */}

          {/* actions */}
          <motion.div className={ styles.actionBlock } initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.4, delay: 0.5 }}>
            <div className={ styles.logoBlock }>
              <img src={ logoImage } alt="Callebaut. Belgium 1911." />
            </div>
            <div className={ styles.actionBlockInner }>
              <AnimatePresence mode="wait">
                <motion.div className={ styles.stepHolder } key={viewModel.currentStep?.stepName ? viewModel.currentStep?.stepName : "empty"} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.4 }}>
                  { viewModel.currentStep?.stepName === 'flavourSelect' && <InputSection viewModel={ viewModel } title={ t('flavour_form_title') } /> }
                  { viewModel.currentStep?.stepName === 'tasteSelect' && <InputSection viewModel={ viewModel } title={ t('taste_form_title') } /> }
                  { viewModel.currentStep?.stepName === 'mouthfeelSelect' && <InputSection viewModel={ viewModel } title={ t('mouthfeel_form_title') } /> }
                </motion.div>
              </AnimatePresence>
            </div>
          </motion.div>
          {/* /actions */}

        </div>
      </div>
    </motion.div>
  );
}
